import { barba, PageComponent } from "barba"

class BarbaFormGet {
    constructor({ node }) {
        this.form = node
        this.submited = false
        this.submitHandler = this.submit.bind(this)
        this.form.addEventListener("submit", this.submitHandler)
    }

    submit(e) {
        if (this.submited) {
            e.preventDefault()
            return false
        }

        let url = new URL(this.form.action)

        new URLSearchParams(new FormData(this.form)).forEach((v, k) => {
            url.searchParams.delete(k)
            url.searchParams.append(k, v)
        })

        barba.go(url.toString())

        this.submited = true
        e.preventDefault()
        return false
    }

    destroy() {
        this.form.removeEventListener("resize", this.submitHandler)
        delete this.form
        delete this.submited
        delete this.submitHandler
    }
}

new PageComponent('form[data-barba-form][method="get"]', BarbaFormGet)
